import { PlatformUtils } from '../utils/platform';
import { useNativeSpeechRecognition } from './useNativeSpeechRecognition';
import { useSpeechRecognitionController as useWebSpeechRecognition } from './useSpeechRecognitionController';
import { TeamColor } from '../types/match';

interface UseSpeechRecognitionProps {
  handleCommand: (command: string[]) => void;
  isController: boolean;
  team1Color: TeamColor;
  team2Color: TeamColor;
}

/**
 * Speech Recognition Router
 * 
 * Routes to the appropriate speech recognition implementation:
 * - iOS native app → Native Speech Recognition (supports external mics)
 * - Web (Android/Desktop/iOS Safari) → Web Speech Recognition
 * 
 * This allows the iOS app to use external microphones via native APIs
 * while keeping the web version working perfectly as-is.
 */
export function useSpeechRecognition(props: UseSpeechRecognitionProps) {
  // iOS native app: use Apple's Speech.framework for external mic support
  if (PlatformUtils.isIOSApp()) {
    return useNativeSpeechRecognition(props);
  }
  
  // Web browsers (Android, Desktop, iOS Safari): use Web Speech API
  return useWebSpeechRecognition(props);
}

// Also export the original for backwards compatibility if needed
export { useSpeechRecognitionController } from './useSpeechRecognitionController';

